<template>
  <div class="error-message-popup">
    <div class="error-message-popup__header">
      <div class="error-message-popup__title">Authorization error</div>
    </div>
    <div class="error-message-popup__body">
      Try to reconnect to Asana
    </div>
    <div class="error-message-popup__footer">
      <button class="error-message-popup__button error-message-popup__button_close"
              @click="close">Close</button>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

export default {
  name: 'ErrorMessagePopup',
  mixins: [BaseModalMixins],
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
  .error-message-popup {
    background-color: #fff;
    padding: 40px;
    border-radius: 15px;

    &__body {
      text-align: center;
    }

    &__title {
      margin: 0 auto;
      padding-bottom: 40px;
      text-align: center;
      font-size: 24px;
      line-height: 32px;
      color: $rfx-dark-march;
      font-weight: bold;
    }

    &__button {
      width: 100px;
      height: 40px;
      font-size: 10px;
      font-weight: 900;
      cursor: pointer;
      text-transform: uppercase;
      border-radius: 8px;
      outline: none;
      border: none;

      &_close {
        color: $rfx-dark-march;
        /*margin-right: 30px;*/
        margin-left: auto;
      }

      &_disabled {
        pointer-events: none;
        opacity: .5;
      }
    }

    &__footer {
      margin-top: 40px;
      display: flex;
      align-items: center;
    }
  }
</style>
